import { ExpandMore } from '@mui/icons-material';
import {
  Accordion,
  AccordionDetails,
  AccordionDetailsProps,
  AccordionProps,
  AccordionSummary,
  Stack,
  Typography,
} from '@mui/material';
import React, { ReactNode, useState } from 'react';

interface Props extends Omit<AccordionProps, 'children'> {
  label: ReactNode;
  centerLabel?: ReactNode;
  children: AccordionDetailsProps['children'];
}

export default function StyledFormAccordion({ label, centerLabel, children, ...props }: Props): React.JSX.Element {
  const [isOpen, setOpen] = useState<boolean>(false);
  return (
    <Accordion {...props} square disableGutters expanded={isOpen} onChange={() => setOpen(!isOpen)}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Stack direction={'row'} alignItems={'center'} spacing={2}>
          <Typography fontWeight={500}>{label}</Typography>
          {centerLabel &&
            (typeof centerLabel === 'string' ? (
              <Typography color={'text.secondary'} variant={'body2'}>
                {centerLabel}
              </Typography>
            ) : (
              centerLabel
            ))}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}
